import {
  BulkCudPlannedBreaksDocument,
  BulkCudPlannedBreaksMutation,
  BulkCudPlannedBreaksMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useBulkCudPlannedBreaks = () => {
  const [bulkCudPlannedBreak, { loading }] = useMutation(BulkCudPlannedBreaksDocument, {
    extractorFn: (data: BulkCudPlannedBreaksMutation) =>
      data.timePlanningMutations.bulkCudTimeplanningPlannedBreak,
  })

  return {
    loading,
    bulkCud(variables: BulkCudPlannedBreaksMutationVariables) {
      return bulkCudPlannedBreak({ variables })
    },
  }
}
